// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".preview-overlay[data-v-33adc481]{align-items:center;background:var(--tertiary-color);display:flex;font-size:20px;height:100vh;justify-content:center;left:0;position:fixed;text-align:center;top:0;width:100%;z-index:9000}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
